import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=2b01d1ef&scoped=true"
import script from "./Round.vue?vue&type=script&lang=js"
export * from "./Round.vue?vue&type=script&lang=js"
import style0 from "./Round.vue?vue&type=style&index=0&id=2b01d1ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01d1ef",
  null
  
)

export default component.exports